export const LOGIN_URL="/api/ies/v1/user/login"
export const VERIFY_URL="/api/ies/v1/user/verify"
export const GET_PROJECT_URL="/api/ies/v1/project/get_all"
export const INSERT_PROJECT_URL="/api/ies/v1/project/insert_one"
export const SEND_EMAIL_URL="/api/ies/v1/enquiry/email"